<script>
import {mapGetters} from 'vuex'
import ACL from '../../../../domain/acl/tmp-acl'

export default {
  name: 'AclCheckMixins',
  computed: {
    ...mapGetters(['isLogged', 'currentUser']),
    ACL () {
      return ACL
    },
    isAdministradorExclusivo () {
      return [
        5, // rhenrique
        488, // tiagofelipe
        22799, // gabrielmiranda
        23048 // lucianalou
      ].some(id => id === this.currentUser.id)
    }
  },
  methods: {
    possuiACL (acl) {
      return this.ACL.check(acl, this.currentUser.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AclCheckMixins.vue?80a97ad0